import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App';
import { evictServiceWorkers } from './devServiceWorker';

// A service worker left by a built copy of the app on this origin will serve its
// own cached shell over the dev server, silently and indefinitely. Development
// never wants one — see src/devServiceWorker.ts. Not awaited: the app must start
// whatever this finds.
if (import.meta.env.DEV) void evictServiceWorkers();

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
